<template>
  <div id="subtitle" v-if="openSubtitle">
    <div id="top-toolbar">
      <TitleToolbar />
    </div>
    <div id="bottom-main">
       <div v-show="getsoundtrackClipState" class="clipMask"></div>
      <div id="left-area">
        <div id="edit-canvas-area" :style="{background: toggleLoadComp ? 'transparent' : '#f0f0f8'}">
          <CanvasContainer @editorStyle="toggleLoadComp"></CanvasContainer>
        </div>
        <div id="batch">
          <batch></batch>
        </div>
        <div id="timeline-area">
          <template v-if="type === 'video'">
            <TimelineSubtitle  />
          </template>
          <template v-else>
            <TimelineContent  />
          </template>
        </div>
      </div>
      <div id="right-area">
        <!-- 字幕 -->
        <SubtitlePanel v-show="getTimeBarType == 'subtitle'" />
        <!-- 配乐 -->
        <SoundtrackSet v-show="getTimeBarType == 'bgm'"></SoundtrackSet>
        <!-- 配音 -->
        <dubSet v-show="getTimeBarType == 'dub'"></dubSet>
        <noSet v-show="getTimeBarType == 'noSet'"></noSet>
      </div>
    </div>

    <SubtitleQuickMenu></SubtitleQuickMenu>
    <SubtitleExport v-if="isShowExport" />
    <SubtitleMessageDialog></SubtitleMessageDialog>
    <SubtitlePopups />
    <RecordDubbing v-if="loadComp" />
    <Guidance />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TimelineSubtitle from "./components/subtitle/timeline";
import TimelineContent from "./components/timelineContent/timelineContent";
import TitleToolbar from "./components/subtitle/titleToolbar/titleToolbar";
import SubtitleQuickMenu from "./components/subtitle/quickMenu/subtitleQuickMenu";
import SubtitleNav from "./components/subtitle/subtitleNav";
import SubtitlePanel from "./components/subtitle/subtitlePanel";//字幕
import SoundtrackSet from "./components/subtitle/soundtrack/soundtrackSet";//配乐
import dubSet from "./components/subtitle/dubbing/dubSet";//配音
import noSet from "./components/subtitle/noSelectSet";//没有设置
import EditToolbar from "./components/subtitle/editToolbar";
import SubtitleExport from "./components/subtitle/subtitleExport";
import CanvasContainer from "./components/subtitle/editCanvas/canvasContainer";
import SubtitleMessageDialog from "./components/SubtitleMessageDialog";
import SubtitlePopups from "./components/subtitle/subtitlePopups";
import Keyboard from "./components/subtitle/keyboard";
import Guidance from "./components/subtitle/subtitleGuidance";
import RecordDubbing from "./components/subtitle/record/record";
import batch from './components/subtitle/batch.vue';

export default {
  data () {
    return {
      type: "editor",
      loadComp: false
    };
  },
  mixins: [Keyboard],
  computed: {
    ...mapGetters({
      isShowExport: "subtitleExport/isShowExport",
      downFonts: "downFonts",
      getTimeBarType: "addSoundtrack/getTimeBarType",
      openSubtitle: "subtitle/openSubtitle",
      getsoundtrackClipState: "soundtrackSet/getsoundtrackClipState"
    }),
  },
  watch: {
  },
  created () {
    this.initData();
    this.downFonts.forEach((font) => this.loadFonts(font.value));
    this.getCheckFont();
  },
  mounted () {

    // setInterval(() => {
    //   let div = document.getElementsByClassName("pace  pace-inactive")[0];
    //   if (div) div.style.display = "none";
    // }, 700);

    this.upDataUserMsg();
  },
  methods: {
    toggleLoadComp () {
      setTimeout(() => {
        this.loadComp = true;
      }, 0);
      // let toolElem = document.querySelector('#app > .Tool');
      // setTimeout(() => {
      //   let subtitleWrapperElem = document.querySelector('#subtitleEditor-container');
      //   let subtitleWrapperRect = subtitleWrapperElem.getBoundingClientRect();
      //   let playerElem = document.querySelector('#editor > [id^=player_]');
      //   let palyerRect = playerElem.getBoundingClientRect();
      //   let wrapperElem = document.querySelector('#editor');
      //   let wrapperRect = wrapperElem.getBoundingClientRect();
      //   let d = subtitleWrapperRect.x - palyerRect.x;
      //   wrapperElem.dataset.dl = d;
      //   let dd = parseFloat(wrapperRect.x || 0) + d;
      //   this.$store.commit("save_MaterialPane", { width: dd });
      //   // toolElem.style.opacity = 1;
      //   toolElem.style.display = 'block';
      // }, 500)
    },
    initData () {
      if (!this.$route.subtitle) {
        this.type = "editor";
      } else {
        this.type = "video";
      }
    },
    upDataUserMsg () {
      if (!this.$route.subtitle) return;
      this.$http.get("/api/session").then((res) => {
        // 请求用户数据
        let { data: resData } = res.data;

        this.$store.commit("save_UserId", resData.id);

        // 临时体验会员
        // if (resData.tmpLevelType != null && resData.tmpLevelType > 1) {
        //   resData.level = resData.tmpLevel;
        //   resData.levelType = resData.tmpLevelType;
        // }

        // if (resData.tmpLevelType != null && resData.tmpLevelType === 0) {
        //   resData.levelType = 0;
        //   resData.level = resData.tmpLevel;
        // }

        this.$store.commit("toggle_UserMsg", resData);
        this.$bus.emit("upDataUserMsg_vue_done");
      });
    },
    loadFonts (font) {
      let _this = this;
      // 下载字体
      fetch(this.$handleAssetsUrl(font)).then(function (res) {
        if (!res.ok) console.error('load font "' + font + '" fail:', res);
        // 添加font-face
        var style =
          '<style type="text/css">\n' +
          "@font-face {" +
          'font-family: "' +
          font.split("/").pop() +
          '";' +
          'src: url("' +
          res.url +
          '");';
        var visualDom = "<div>来画动画</div>";
        $("head").prepend(style);
        $(visualDom)
          .appendTo($("body"))
          .css({
            fontFamily: `"${font.split("/").pop()}"`,
            visibility: "hidden",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: -10,
          });
        return Promise.resolve();
      });
    },
    getCheckFont (toolFont = []) {
      let downFonts = [];
      let downFont = null;
      let getDelayTime = function (time) {
        if (!time) return;
        let now = new Date(time * 1000);
        let fu = now.setFullYear(now.getFullYear() + 1);
        fu = new Date(fu).toISOString();
        fu = fu.split(/-|T/);
        fu.length = 3;
        return fu.join(".");
      };
      // toolFont.unshift(this.downFonts[1].value);
      // toolFont.unshift(this.downFonts[0].value);

      this.$http
        .get("/api/user/brand/font")
        .then((res) => {
          if (res.status === 200 && res.data.code === 200 && res.data.data) {
            let data = res.data.data;
            let textOption = {};
            for (let k in data) {
              let title = data[k];
              if (k === "title" || k === "subtitle" || k === "content" || title.font.title !== '方正黑体') {
                this.loadFonts(title.font.url);
                toolFont.push(title.font.url);
                textOption[k] = {
                  fontId: title.font.id,
                  font: {
                    fontFamilyUrl: title.font.url,
                    fontSize: title.size || 80,
                    color: title.color || "#303233",
                    fontWeight: title.blod === 0 ? "normal" : "bold",
                    fontStyle: title.italic === 0 ? "normal" : "italic",
                    textDecoration:
                      title.underline === 0 ? "none" : "underline",
                  },
                };
              }
              if (k === "fontList") {
                let brandList = [];
                data[k].forEach((v) => {
                  brandList.push({
                    id: v.id,
                    value: v.url,
                    label: v.title,
                    fontUrl: v.fontUrl,
                  });
                });
                this.$store.commit("toggle_brandList", brandList);
              }
            }
            this.$store.commit("toggle_textOption", textOption);
          }
          toolFont = [...new Set(toolFont)];
          // console.log('toolFont toolFont', toolFont);
          this.$http
            .get(
              "/api/common/material?style=1&type=6&sOfPage=500&fPage=500&pIndex=1"
            )
            .then((res) => {
              if (res.data.data) {
                toolFont.forEach((item) => {
                  for (let i in res.data.data) {
                    downFont = res.data.data[i];
                    if (item === downFont.url) {
                      downFonts.push({
                        id: downFont.id,
                        value: downFont.url,
                        fontUrl: downFont.fontUrl,
                        label: downFont.title,
                        payType: downFont.payType,
                        isPay: downFont.tt ? true : false,
                        price: downFont.price,
                        delayTime:
                          downFont.tt && getDelayTime(downFont.tt.createTime),
                        status: 2,
                      });
                      break;
                    }
                  }
                });
                this.$store.commit("toggle_downFonts", downFonts.concat(this.downFonts));
              }
            });
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  components: {
    batch,
    TimelineSubtitle,
    TimelineContent,
    SubtitleNav,
    SubtitlePanel,
    TitleToolbar,
    SubtitleQuickMenu,
    EditToolbar,
    SubtitleExport,
    CanvasContainer,
    SubtitleMessageDialog,
    SubtitlePopups,
    Keyboard,
    Guidance,
    SoundtrackSet,
    dubSet,
    noSet,
    RecordDubbing
  },
};
</script>

<style lang="scss">
@import './src/style/icons';
</style>
<style lang="scss" scoped>
.clipMask {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  background-color: rgba($color: #000000, $alpha: 0.6);
  z-index: 99;
}
#subtitle {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: transparent;
  z-index: 10;
  display: flex;
  flex-direction: column;
  #top-toolbar {
    position: relative;
    height: 60px;
    width: 100%;
    background-color: burlywood;
  }
  #bottom-main {
    position: relative;
    width: 100%;
    height: calc(100% - 60px);
    background-color: transparent;
    display: flex;
    flex-direction: row;
    #left-area {
      width: calc(100% - 246px);
      height: 100%;
      display: flex;
      flex-direction: column;
      #edit-canvas-area {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: transparent;
      }
      #timeline-area {
        width: 100%;
        height: 190px;
        flex-shrink: 0;
        background-color: #f0f0f8;
      }
    }
    #right-area {
      height: 100%;
      width: 246px;
      background-color: chocolate;
      flex-shrink: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/AppSubtitle.vue